import { z } from "zod";

export const boardDataSchema = z
  .object({
    jsonData: z.string().optional(),
  })
  .catchall(z.unknown());

export type BoardDataType = z.infer<typeof boardDataSchema>;
